<template>
    <div class="statement_container">
        <cv-navbar/>
        <div class="container_main">
            <div class="main_tab pad-t-20">
                <div class="tab_con">
                    <p class="tab_item pointer" @click="$router.push('/mentor/tasks')">导师首页</p>
                    <p class="tab_item pointer" @click="$router.push('/mentor/tasks/statement')">账单页</p>
<!--                    <p class="tab_item pointer">下载excel</p>-->
                </div>
            </div>
            <div class="statement_table pad-t-20">
                <div class="main_table_1">
                    <el-table :data="tableData" stripe
                              :header-cell-style="{background:'rgb(245,245,247)',color:'#404040',fontWeight:'bold',fontSize:'14px'}"
                              style="background-color: transparent;color: rgb(125,125,126);">
                        <el-table-column prop="date" min-width="36" label="计数">
                        </el-table-column>
                        <el-table-column prop="name" min-width="50" label="订单编号">
                        </el-table-column>
                        <el-table-column prop="" min-width="36" label="用户名">
                        </el-table-column>
                        <el-table-column prop="" min-width="36" label="文件名">
                        </el-table-column>
                        <el-table-column prop="" min-width="36" label="创建于">
                        </el-table-column>
                        <el-table-column prop="" min-width="36" label="完成于">
                        </el-table-column>
                        <el-table-column prop="" min-width="36" label="订单价格">
                        </el-table-column>
                        <el-table-column prop="" min-width="36" width="150" label="导师薪酬（70%）">
                        </el-table-column>
                        <el-table-column prop="" min-width="36" label="备注">
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import cvNavbar from '@/components/base/navbar';
import pcFooter from '@/components/base/pcFooter';
import api from "@/api";

export default {
    components: {
        cvNavbar,
        pcFooter
    },
    data() {
        return {
            tableData: [],

        }
    },
    mounted() {

    },
    methods: {}
}
</script>

<style lang="scss">
.statement_table {
    .main_table_1 {
        .el-table--border::after, .el-table--group::after, .el-table::before {
            background-color: #ddd !important;
        }

        .el-table--border,
        .el-table--group {
            border-color: #ddd !important;
        }

        .el-table td,
        .el-table th.is-leaf {
            border-bottom: 1px solid #ddd;
        }

        .el-table--border th,
        .el-table--border th.gutter:last-of-type {
            border-bottom: 1px solid #ddd;
        }

        .el-table--border td,
        .el-table--border th {
            border-right: 1px solid #ddd;
        }
    }
}
</style>

<style lang="scss" scoped>
.display {
    display: block;
}

.statement_container {
    margin-top: 56px;
    width: 100%;
    height: 100%;
    background-color: rgb(245, 245, 247);

    .container_main {
        //overflow: hidden;
        //margin: 0 auto;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        padding: 0 40px;
        min-width: 1220px;
        flex-wrap: wrap;
        //background-color: blueviolet;
        .main_tab {
            display: flex;
            justify-content: flex-start;
            //float: right;
            width: 100%;
            height: 30px;
            line-height: 30px;
            //background-color: bisque;
            text-align: center;

            .tab_con {
                width: auto;
                overflow: hidden;
                border-radius: 4px;
                display: flex;

                .tab_item {
                    margin-right: 5px;
                    font-size: 14px;
                    height: 30px;
                    line-height: 30px;
                    color: #fff;
                    padding: 0 15px;
                    border-radius: 6px;
                    background-color: #ff6600;
                    border-color: #ff6600;
                }
                //
                //.tab_item:nth-child(1) {
                //    background-color: #ff6600;
                //    border-color: #ff6600;
                //}
                //
                //.tab_item:nth-child(2) {
                //    background-color: #ff6600;
                //    border-color: #ff6600;
                //}

                .tab_item:nth-child(3) {
                    background-color: #d9534f;
                    border-color: #d43f3a;
                }

                .tab_item:hover {
                    opacity: 0.8;
                }
            }
        }

        .table {
            width: 100%;
            //margin-top: 40px;
            .main_table_1 {

            }
        }
    }


}

</style>